import store from '@/store'

export default [
  {
    path: '/location-settlements',
    name: 'location-settlement',
    meta: { requiresAuth: true },
    component: () => import('@/pages/location-settlement/form.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('locationSettlement/dataBeforeCreate')
      next()
    }
  },
  {
    path: '/location-settlements/:id',
    name: 'location-settlement-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/location-settlement/form.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('locationSettlement/dataBeforeCreate')
      await store.dispatch('locationSettlement/find', to.params.id)
      next()
    }
  }
]
